import { render, staticRenderFns } from "./v4wardclient.vue?vue&type=template&id=896273f8&"
import script from "./v4wardclient.vue?vue&type=script&lang=js&"
export * from "./v4wardclient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports